import { z } from 'zod';
import { AlertSubscriptionSchema } from '../base.js';
export const GetAlertSubscriptionQueryRequestSchema = z.object({
    alertLevel: z.string(),
});
export const GetAlertSubscriptionRequestSchema = GetAlertSubscriptionQueryRequestSchema;
export const GetAlertSubscriptionResponseSchema = AlertSubscriptionSchema.array();
